import gql from "graphql-tag"

const query = gql`
  query UserWalletList($userId: String!){
    userWalletList(userId: $userId){
      results {
        ownerId
        walletId
        type
        typeId
        availableBalance
        currency
      }
      limit
      offset
    }
  }
`

export const toString = query.loc.source.body

export default query
